import {
  AdaptiveImage,
  ArrowNew,
  Box,
  Flex,
  ButtonLink,
  Card,
  Highlight,
  MiddleTitle,
  Section,
  SmallTitle,
  Text,
  VideoWithImage,
  LayoutWithoutHead,
  HandWritten,
  CheckList,
  Seo,
  Link,
  HeaderHome,
  Testimonials,
  TestimonialWithPicture,
  AnimationTyping,
  CardsMulti,
  CardMulti,
  Wheel,
  WheelItem,
} from '../../components'

import React from 'react'
import btoa from 'btoa'
import translations from '../../translations'

export const Head = () => {
  // pageContext is also available in props of HEAD=> See how to set it in gatsby-node.js and use it
  return (
    <Seo
      hreflangs={[
        { lang: 'fr', href: 'https://www.assoconnect.com/' },
        { lang: 'en-us', href: 'https://www.springly.org/en-us/' },
      ]}
      meta={{
        title:
          "L'outil en ligne qui facilite la vie des responsables d'associations | AssoConnect",
        //TODO : prévenir Valeria du changement de title - impact WF Hubspot
        description:
          'llll➤ Collectes de paiement, comptabilité, gestion des membres et communication. Comme plus de 40 000 associations, adoptez AssoConnect !',
      }}
    />
  )
}

const IndexPage = () => {
  return (
    <LayoutWithoutHead>
      <HeaderHome
        translations={translations.fr_FR}
        image={{
          src: 'pages/index/homeBanner',
          alt: 'logiciel gestion association complet',
          width: '661',
          height: '587',
          type: 'webp',
        }}
        className="hidden-desktop"
        title={<>Donnez un nouvel élan à votre association</>}
        videoId="6yurbg1g3b"
        hubspotId={process.env.GATSBY_HUBSPOT_ID}
        noticeText={{
          text: 'Plus de 40 000 associations nous font confiance',
          googleText: '4,8 sur Google',
          facebookText: '4,6 sur Facebook',
          capterraText: '4,8 sur Capterra',
        }}
        imageUrlForNotice={[
          'common/clients/organizations/acbb-carrousel-n',
          'common/clients/organizations/avf-carrousel-new',
          'common/clients/organizations/aviron-bayonnais-carrousel-n',
          'common/clients/organizations/banques-alimentaires-carrousel-n',
          'common/clients/organizations/croix-rouge-carrousel-n',
          'common/clients/organizations/dgac-carrousel-n',
          'common/clients/organizations/endofrance-carrousel-n',
          'common/clients/organizations/ffbb-carrousel-n',
          'common/clients/organizations/ffco-carrousel-n',
          'common/clients/organizations/ffdanse-carrousel-n',
          'common/clients/organizations/ffepgv-carrousel-n',
          'common/clients/organizations/france-rein-carrousel-n',
          'common/clients/organizations/gmouv-carrousel-n',
          'common/clients/organizations/hémophiles-carrousel-n',
          'common/clients/organizations/lgbti-carrousel-n',
          'common/clients/organizations/occe-carrousel-n',
          'common/clients/organizations/phi-carrousel-n',
          'common/clients/organizations/samu-carrousel-n',
          'common/clients/organizations/sciences-po-carrousel-n',
          'common/clients/organizations/ville-velo-carrousel-n',
        ]}
        checkListContent={[
          <>
            <strong>Collectez</strong> vos adhésions et dons
          </>,
          <>
            <strong>Gérez</strong> votre comptabilité
          </>,
          <>
            <strong>Rayonnez</strong> autour de vous
          </>,
        ]}
      />
      <Section background={{ color: 'blue' }}>
        <Box align="center" className="pb-medium">
          <MiddleTitle className="pt-small">
            Pour les assos qui <Highlight>changent la donne</Highlight>,{' '}
            <br className="hidden-mobile" />
            dans tous les secteurs, de 8 à 800 000 membres
          </MiddleTitle>
        </Box>
      </Section>

      <Wheel
        ctaText="Commencer gratuitement"
        ctaLink="https://app.assoconnect.com/sign-up/first?subscription=SERENITE"
        mainTitle={
          <>
            L'outil pour
            <br />
            <Highlight>tous vos besoins</Highlight>
          </>
        }
      >
        <WheelItem title="Comptabilité" animation="compt" href="/comptabilite/">
          Votre trésorerie, plus sereine que jamais
        </WheelItem>
        <WheelItem title="Communication" animation="commu" href="/emailing/">
          Les bons messages, envoyés aux bonnes personnes
        </WheelItem>
        <WheelItem
          title="Site internet"
          animation="site"
          href="/site-internet/"
        >
          La vitrine qu’il vous manquait pour vous démarquer
        </WheelItem>
        <WheelItem title="Membres" animation="members" href="/crm/">
          La base de données toujours à jour dont vous rêviez
        </WheelItem>
        <WheelItem title="Paiements" animation="collectes" href="/paiements/">
          Adhésions, dons et billetteries, sans aucun souci
        </WheelItem>
      </Wheel>

      <Section background={{ block: 'left' }}>
        <Box width={1 / 12} />
        <Box width={5 / 12}>
          <MiddleTitle align="left" id="valeurs">
            Laissez <Highlight>Apolline</Highlight> vous présenter AssoConnect
          </MiddleTitle>
          <Text className="pt-small">
            Vous méritez un{' '}
            <Link href="/" nofollow={false}>
              outil de gestion
            </Link>{' '}
            à la hauteur de votre impact et des défis que vous relevez. <br />
            <br />
            Bonne nouvelle : vous l'avez sous les yeux.
          </Text>
          <ButtonLink
            className="pt-medium"
            href={btoa(
              'https://app.livestorm.co/assoconnect/demonstration-assoconnect?utm_source=interne&utm_medium=website&utm_source=hp'
            )}
            theme="white"
          >
            Voir la démo complète
          </ButtonLink>
        </Box>
        <Box width={6 / 12}>
          <VideoWithImage
            image="pages/equipe/apolline-brunat-miniature-new"
            videoId="9a9ib2i2ko"
            autoplay
          />
        </Box>
      </Section>
      <Section background={{ color: 'blue' }}>
        <Box align="center" className="pb-small">
          <MiddleTitle className="pt-small">
            Pour celles et ceux qui ont une double (
            <Highlight>voire triple</Highlight>) casquette
          </MiddleTitle>
        </Box>
      </Section>
      <Section alignItems="stretch" background={{ color: 'clearBlue' }}>
        <Box>
          <MiddleTitle>
            Rendons votre quotidien <Highlight>plus doux</Highlight>
          </MiddleTitle>
        </Box>

        <CardsMulti
          titles={[
            'Votre asso est organisée',
            'Votre projet se démarque',
            'Votre compta est une fierté',
            'Votre équipe collabore mieux',
          ]}
        >
          <CardMulti
            title={
              <>
                Adieu système D, <br />
                bonjour <Highlight>asso organisée</Highlight>
              </>
            }
            image="components/wheel/hoc-fonct-un"
          >
            <Text color="black">
              <b>
                Base de membres, comptabilité, cotisations, site internet...
              </b>
            </Text>
            <br />
            <Text color="extraDarkGrey">
              Avec AssoConnect, votre organisation devient carrée en moins de
              temps qu'il n'en faut pour dire “adhérer”. La preuve : 92 % de nos
              associations utilisatrices affirment que notre outil les aide à se
              structurer.
            </Text>
          </CardMulti>
          <CardMulti
            title={
              <>
                Prenez la lumière : <br />
                <Highlight>il est temps pour vous de briller</Highlight>
              </>
            }
            image="components/wheel/hoc-fonct-deux"
          >
            <Text color="black">
              <b>Vous allez aimer votre nouvelle visibilité. </b>
            </Text>
            <br />
            <Text color="extraDarkGrey">
              Attirez plus de bénévoles en éliminant les tâches rébarbatives.
              Démarquez-vous grâce à un site web professionnel, intuitif et
              moderne. Communiquez facilement avec vos différents groupes de
              membres.
            </Text>
            <br />
          </CardMulti>
          <CardMulti
            title={
              <>
                L’outil préféré <br />
                des <Highlight>trésorières et trésoriers</Highlight>
              </>
            }
            image="components/wheel/hoc-fonct-trois"
          >
            <Text color="black">
              <b>
                Finis les allers-retours à la banque pour déposer des chèques.
              </b>
            </Text>
            <br />
            <Text color="extraDarkGrey">
              La compta, plus besoin d’en faire tout un plat : AssoConnect gère
              instantanément ce qui vous prenait autrefois une éternité. Vos
              documents comptables sont irréprochables, vous pouvez souffler !
            </Text>
          </CardMulti>
          <CardMulti
            title={
              <>
                Le travail en équipe
                <br />
                <Highlight>devient facile et agréable</Highlight>
              </>
            }
            image="components/wheel/hoc-fonct-quatre"
          >
            <Text color="black">
              <b>
                Avec AssoConnect, tout est centralisé, toujours à jour et
                disponible.
              </b>
            </Text>
            <br />
            <Text color="extraDarkGrey">
              Un membre du bureau démissionne : évitez la perte de documents et
              d’informations. <br />
              Vous accueillez un nouveau bénévole : facilitez la passation et
              l’intégration. <br />
              Vous travaillez à plusieurs : augmentez la transparence et
              diminuez le risque d'erreurs.
            </Text>
          </CardMulti>
        </CardsMulti>
      </Section>
      <Section background={{ color: 'blue' }}>
        <Box align="center">
          <MiddleTitle className="pt-small">
            Gagnez <Highlight>une demi-journée</Highlight> de travail par
            semaine
          </MiddleTitle>
          <Text className="pt-small" align="center">
            *Sondage réalisé auprès de nos associations utilisatrices
          </Text>
        </Box>
      </Section>
      <Section background={{ block: 'right' }}>
        <Box width={6 / 12} overflowLeft>
          <AdaptiveImage
            src="components/wheel/dash-benefits-new"
            alt="logiciel association"
          />
        </Box>

        <Box width={6 / 12}>
          <MiddleTitle color="extraDarkGrey" align="left">
            L'outil de référence pour les
          </MiddleTitle>
          <MiddleTitle align="left" display="block" color="extraDarkGrey">
            <AnimationTyping
              withHighlight
              data={[
                'associations sportives',
                'associations en réseau',
                'associations étudiantes',
                'fondations',
                'associations médico-sociales',
                'associations de loisirs',
                'associations professionnelles',
                'clubs de sport',
                'fonds de dotation',
                'têtes de réseaux associatifs',
                'associations caritatives',
                "associations de protection de l'environnement",
                'associations culturelles',
                'fondations',
                'associations politiques',
                "associations d'éducation",
                'associations religieuses',
              ]}
            />
          </MiddleTitle>

          <Flex flexDirection={['column', 'row']} custom={false}>
            <ButtonLink href="/associations/" theme="white">
              et pour mon asso ?
            </ButtonLink>
            <ButtonLink
              margin="0 0 0 1rem"
              href={btoa('/reseaux/federations/')}
              theme="line-middleGrey"
            >
              et pour ma fédé ?
            </ButtonLink>
          </Flex>
        </Box>
      </Section>
      <Section background={{ block: 'left' }}>
        <Box width={1 / 12} />
        <Box width={5 / 12}>
          <MiddleTitle align="left" id="valeurs">
            Nous sommes là <br />
            pour <Highlight>votre association</Highlight>
          </MiddleTitle>
          <Text className="pt-small">
            Toujours avec simplicité, bienveillance et excellence.{' '}
            <b>Arnaud de La Taille</b>, cofondateur d'AssoConnect, vous
            explique.
            <ButtonLink
              className="pt-medium"
              theme="blue"
              href={btoa('/qui-sommes-nous/')}
            >
              Découvrir notre belle histoire
            </ButtonLink>
          </Text>
        </Box>
        <Box width={6 / 12}>
          <VideoWithImage
            image="pages/equipe/miniature-arnaud-new-n"
            videoId="ljtuzoajao"
          />
        </Box>
      </Section>
      <Section background={false}>
        <Box className="pb-small">
          <MiddleTitle>
            Profitez d’une assistance <br></br>
            <Highlight> gratuite et illimitée</Highlight>
          </MiddleTitle>
        </Box>
        <Box width={1 / 12} />
        <Box width={5 / 12}>
          <AdaptiveImage
            src="pages/equipe/eva-david-assistance-new-n"
            type="jpg"
            roundShape="ROUNDED"
            alt="assoconnect support assistance"
            maxDpi={2}
          />
        </Box>
        <Box width={1 / 2} alignItems="top">
          <SmallTitle className="pb-small" color="middleGrey" align="left">
            Quelle que soit votre demande, nous sommes là <br></br>pour vous
            aider.
          </SmallTitle>

          <CheckList
            content={[
              'Disponibles par mail, du lundi au vendredi',
              'Nous vous répondons sous 24h ouvrées',
              '350 articles et vidéos pour vous guider',
            ]}
          />
          <ButtonLink
            className="pt-small"
            align="left"
            href="/contact/"
            theme="blue"
            target="_self"
          >
            Contactez-nous
          </ButtonLink>
        </Box>
      </Section>
      <Section alignItems="stretch" background={false}>
        <Box className="pb-small">
          <MiddleTitle>
            Du contenu pour <Highlight> vous simplifier la vie</Highlight>
          </MiddleTitle>
        </Box>

        <CardsMulti type="cards">
          <Card>
            <AdaptiveImage
              src="pages/ressources/contenu-articles-new"
              alt="articles"
              disableLazyLoad
              visibleByDefault
            />
            <SmallTitle className="pt-small" color="black">
              Articles
            </SmallTitle>
            <Text className="pt-small">
              Tout pour vous former, vous renseigner et vous donner de nouvelles
              idées. <br></br>
              <br></br>
              <b>Par exemple : Comment créer une newsletter qui marche ? </b>
            </Text>
            <ButtonLink
              className="pt-medium"
              align="center"
              href="/blog"
              theme="blue"
              target="_self"
            >
              Trouver l'inspiration
            </ButtonLink>
          </Card>

          <Card>
            <AdaptiveImage
              src="pages/ressources/contenu-temoignages-new"
              alt="avis"
              disableLazyLoad
              visibleByDefault
            />
            <SmallTitle className="pt-small" color="black">
              Témoignages
            </SmallTitle>
            <Text className="pt-small">
              Des dizaines d’assos vous racontent leurs expériences (et
              réussites) avec nous.
              <br></br> <br></br>
              <b>
                Alain, Renée, Stéphane… Leur histoire fera écho à la vôtre !
              </b>
            </Text>
            <ButtonLink
              className="pt-medium"
              align="center"
              href="/blog/tag/etude-de-cas-client/"
              theme="blue"
              target="_self"
            >
              Découvrir leurs récits
            </ButtonLink>
          </Card>

          <Card>
            <AdaptiveImage
              src="pages/ressources/contenu-guides-new"
              alt="livres blancs"
              disableLazyLoad
              visibleByDefault
            />
            <SmallTitle className="pt-small" color="black">
              Livres blancs
            </SmallTitle>
            <Text className="pt-small">
              Des guides complets pour aider votre association et faire de vos
              projets des succès.
              <br></br> <br></br>
              <b>Notre guide du trésorier, mieux qu'un best seller d’été !</b>
            </Text>
            <ButtonLink
              className="pt-medium"
              align="center"
              href="/ressources/guides-associations/"
              theme="blue"
              target="_self"
            >
              À moi la lecture
            </ButtonLink>
          </Card>

          <Card>
            <AdaptiveImage
              src="pages/ressources/contenu-webinaires-new"
              alt="webinaires"
              disableLazyLoad
              visibleByDefault
            />
            <SmallTitle className="pt-small" color="black">
              Webinaires
            </SmallTitle>
            <Text className="pt-small">
              Nos incontournables formations en ligne sur les sujets clés pour
              développer votre activité.
              <br></br>
              <br></br>
              <b>Toujours gratuites, et la bonne humeur est garantie !</b>
            </Text>
            <ButtonLink
              className="pt-small"
              align="center"
              href="/ressources/formations-en-ligne/"
              theme="blue"
              target="_self"
            >
              Réserver votre place
            </ButtonLink>
          </Card>
        </CardsMulti>
      </Section>
      <Section background={{ color: 'blue' }}>
        <Box className="pb-medium">
          <MiddleTitle>
            Vous avez des besoins
            <br className="hidden-mobile" />
            <Highlight>nous avons les solutions</Highlight>
          </MiddleTitle>
        </Box>
        <Box width={2 / 12} />
        <Box width={4 / 12}>
          <ArrowNew arrowColor="white">
            <HandWritten rotate="-8">100% gratuit</HandWritten>
          </ArrowNew>

          <Card theme="blue" hoverAnimation>
            <AdaptiveImage
              src="pages/tarifs/prix-offre-liberte"
              alt="logiciel-association-liberté-assoconnect"
            />
            <SmallTitle>Offre Liberté</SmallTitle>
            <Text className="pt-small" align="center">
              Pour vous concentrer sur vos collectes
            </Text>
            <ButtonLink
              className="pt-small"
              align="center"
              href="https://app.assoconnect.com/sign-up/first?subscription=LIBERTE"
              theme="yellow"
              target="_self"
            >
              Revenir à l'essentiel
            </ButtonLink>
          </Card>
        </Box>
        <Box width={4 / 12}>
          <Card theme="blue" hoverAnimation>
            <ArrowNew direction="left" position="right" arrowColor="white">
              <HandWritten rotate="8">Solution complète</HandWritten>
            </ArrowNew>

            <AdaptiveImage
              src="pages/tarifs/prix-offre-serenite-26-euros"
              alt="logiciel-association-comptabilite-assoconnect"
            />
            <SmallTitle className="pb-small">Offre Sérénité</SmallTitle>

            <Text align="center">Pour gérer votre association de A à Z</Text>
            <ButtonLink
              className="pt-small"
              align="center"
              href="https://app.assoconnect.com/sign-up/first?subscription=SERENITE"
              theme="yellow"
              target="_self"
            >
              Changer la donne
            </ButtonLink>
          </Card>
        </Box>
        <Box width={2 / 12} />
      </Section>
      <Section background={{ color: 'white' }}>
        <Box>
          <MiddleTitle className="pb-medium">
            C'est vous qui en parlez <Highlight>le mieux</Highlight>
          </MiddleTitle>

          <Testimonials>
            <TestimonialWithPicture
              image="common/clients/people/martine-new"
              alt="martine-faury-témoignage"
              statement={
                <>
                  Si on m'enlève AssoConnect ? Ah mais je quitte la fondation !
                  (rires) Non, non, ce n'est pas possible.{' '}
                  <b>Cela me simplifie trop la vie ! </b>
                </>
              }
              authorName="Martine Faury"
              authorRole="Secrétaire"
              nonprofitName="Fondation Leïla Fodil"
              nonprofitNumberOfMembers="1330"
              link="/blog/cas-client-fondation-leila-fodil/"
            />
            <TestimonialWithPicture
              image="common/clients/people/stephane-new"
              imagePosition="RIGHT"
              alt="Stéphane De Giovannetti témoignage"
              statement={
                <>
                  Maintenant, quand on tape le nom de notre club sur Internet,
                  <b> on tombe directement sur notre site</b>. Beaucoup de
                  personnes nous écrivent via notre section Contact, c’est très
                  utilisé !
                </>
              }
              authorName="Stéphane de Giovannetti"
              authorRole="Trésorier "
              nonprofitName="Avenir Bizanos Basket"
              nonprofitNumberOfMembers="200"
            />
            <TestimonialWithPicture
              image="common/clients/people/benedicte-new"
              statement="Pour la première fois, la comptabilité peut être clôturée en août, on ne court plus après le temps. Pourtant, je n’ai pas de formation comptable, je suis médecin. C’est bien la preuve que la comptabilité sur AssoConnect est à la portée de tous !"
              authorName="Bénédicte Pik"
              authorRole="Trésorière "
              nonprofitName="CSL Bullion"
              nonprofitNumberOfMembers="958"
            />
            <TestimonialWithPicture
              image="common/clients/people/raphael-new"
              imagePosition="RIGHT"
              alt="Raphaël Santerne témoignage"
              statement={
                <>
                  Je me suis dit que ça avait l'air simple et que je devais me
                  lancer.{' '}
                  <b>C’était la première fois que je créais un site internet</b>
                  , j’ai trouvé l’expérience <b>ludique, facile et intuitive</b>
                  .
                </>
              }
              authorName="Raphaël Santerne"
              authorRole="Président"
              nonprofitName="APE Lycée Jean Trouvé"
              nonprofitNumberOfMembers="400"
              link="/blog/cas-client-assoconnect-ape-jean-prouve/"
            />
            <TestimonialWithPicture
              image="common/clients/people/alain-new"
              alt="Alain Rosello témoignage"
              statement={
                <>
                  Nous avons été très agréablement surpris, car{' '}
                  <b>
                    80 % de nos membres ont adhéré en ligne, même parmi les plus
                    anciens
                  </b>
                  . Aujourd’hui, nous avons atteint notre objectif en termes de
                  nombre d’adhérents, et{' '}
                  <b>les nouvelles adhésions continuent d’arriver</b> ! C’est
                  vraiment <b>un franc succès</b>.
                </>
              }
              authorName="Alain Rosello"
              authorRole="Président"
              nonprofitName="Gym Plaisir Frouzins"
              nonprofitNumberOfMembers="500"
              link="/blog/cas-client-assoconnect-gym-plaisir-frouzins-offre-liberte/"
            />
            <TestimonialWithPicture
              image="common/clients/people/benoit-new"
              imagePosition="RIGHT"
              alt="Benoît Chazelas témoignage"
              statement={
                <>
                  Beaucoup de personnes tournent en association.
                  <b>
                    {' '}
                    Si on doit à chaque fois passer beaucoup de temps pour les
                    former, ça ne vaut pas le coup
                  </b>
                  . Avec AssoConnect, on a un outil qui est le même pour tout le
                  monde. [...] <b>Il y a un vrai enjeu de passation</b>. Demain,
                  si ma trésorière voulait partir, ce sera simple à gérer avec
                  AssoConnect.
                </>
              }
              authorName="Benoît Chazelas"
              authorRole="Président"
              nonprofitName="Atoutprises"
              nonprofitNumberOfMembers="514"
              link="/blog/cas-client-assoconnect-atoutprises-paiement-plusieurs-fois/"
            />
          </Testimonials>
        </Box>
      </Section>
      <Section background={{ color: 'light-blue' }} withGradient>
        <Box width={1 / 12} />
        <Box width={6 / 12}>
          <MiddleTitle align="left">
            AssoConnect est votre allié 💙
            <br className="hidden-mobile" />
            <Highlight>Foncez l’essayer</Highlight> !
          </MiddleTitle>
        </Box>
        <Box width={4 / 12}>
          <ButtonLink
            theme="blue"
            href={btoa(
              'https://app.assoconnect.com/sign-up/first?subscription=SERENITE'
            )}
          >
            Commencer gratuitement
          </ButtonLink>
        </Box>
        <Box width={1 / 12} />
      </Section>
    </LayoutWithoutHead>
  )
}

export default IndexPage
